"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var xor = function xor(O, o) {
  return function () {
    var oi = o * 2;

    for (var _len = arguments.length, I = new Array(_len), _key = 0; _key < _len; _key++) {
      I[_key] = arguments[_key];
    }

    if (I.length >= 2) {
      var ii = I[1] * 2;
      O[oi] = I[0][ii];
      O[oi + 1] = I[0][ii + 1];
    }

    for (var i = 2; i < I.length; i += 2) {
      var _ii = I[i + 1] * 2;

      O[oi] ^= I[i][_ii];
      O[oi + 1] ^= I[i][_ii + 1];
    }
  };
};

var _default = xor;
exports.default = _default;